import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col } from "reactstrap"

// components
import Applications from "pages/Dashboard/applications"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"
import ApplicationFilter from "components/Filter/ApplicationFilter"

let appService = null
let plasticsUser = null
let staffService = new Staff()

const ManualApplications = () => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [manualApplications, setmanualApplications] = useState()
  const [searchMode, setsearchMode] = useState(false)
  const [filterValues, setFilterValues] = useState({
    search: "",
    application_status: "",
    date_from: "",
    date_to: "",
    officer_id: ""
  })

  const toggle = () => {
    setMenu(!menu)
  }

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)

    setuser(userObj)
    plasticsUser = appService.getStrategy("officer")
    plasticsUser.getManualApplications(userObj.id, 1).then(response => {
      
      if (response.status) {
        setmanualApplications(response.data)
        setmounted(true)
      }
    })
  }, [])

  const paginate = page => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    // If we are in search mode, we will call the search endpoint instead
    if (searchMode) {
      appService.searchApplications(filterValues, page).then(response => {
        setmanualApplications(response.data)
      })
    } else {
      plasticsUser.getManualApplications(userObj.id, page).then(response => {
        if (response.status) {
          setmanualApplications(response.data)
        }
      })
    }
  }

  const initiateSearch = (data) => {
    data = {...data, application_status: "DG APPROVED", officer_id: user.id}
    setsearchMode(true)
    setFilterValues(data)
    appService.searchApplications(data, null).then(response => {
      if (response?.code && response.code == 200) {
        if (response.data.total == 0) {
          setmanualApplications({data: []})
        } else {
          setmanualApplications(response.data)
        }
      } else {
        setmanualApplications({data: []})
      }
    })
  }

  const turnOffSearchMode = () => {
    setsearchMode(false)
    paginate(0)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manual Applications | Staff</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Manual Applications</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    All manual applications will show up here.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              {/* <ApplicationFilter allApplications={false} handleSearch={initiateSearch} turnOffSearch={turnOffSearchMode} /> */}
              <Applications
                viewOnly={true}
                user={user}
                data={manualApplications}
                paginate={paginate}
                isManualApplication={true}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ManualApplications
